document.querySelectorAll('.reviews-container').forEach(reviewsContainer => {
    reviewsContainer.addEventListener('scroll', function(event) {
        let reviewsElements = event.target.querySelectorAll('.review');
        let mobileTicks = reviewsContainer.closest('content-reviews').querySelector('.mobile-ticks');
        mobileTicks.querySelectorAll('.active').forEach(mobileTick => { mobileTick.classList.remove('active'); });

        let visibleElement = 0;
        for(var i =  0; i < reviewsElements.length; i++) {
            if (reviewsElements[i].getBoundingClientRect().x < 150) {
                visibleElement = i;
            }
        }

        mobileTicks.querySelector('.tick:nth-of-type('+(visibleElement+1)+')').classList.add('active');
    })
})

document.querySelectorAll('.mobile-ticks .tick').forEach(mobileTick => {
    mobileTick.addEventListener('click', function(event) {
        let reviewsContainer = event.target.closest('content-reviews').querySelector('.reviews-container');
        reviewsContainer.scrollTo({top: 0, left: reviewsContainer.querySelector('.review:nth-of-type('+(parseInt(event.target.getAttribute('data-index')))+')').offsetLeft});
    })
})